






































































































































































import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { MetaInfo } from 'vue-meta';
import { Resolve } from 'vue-di';
import { faPrescription, faChevronUp, faChevronDown } from '@fortawesome/pro-regular-svg-icons';
import { mapKeys } from 'lodash';
import Header from '~/components/Header/Header.vue';
import FloatingFooter from '~/components/Footer/FloatingFooter.vue';
import Footer from '~/components/Footer/Footer.vue';
import StaticFooter from '~/components/Footer/StaticFooter.vue';
import ScrollingFooter from '~/components/Footer/ScrollingFooter.vue';
import ConfigurationDrawer from '~/components/configuration/ConfigurationDrawer.vue';
import theme from '~/settings/theme';
import SessionModule from '~/store/session';
import LayoutModule from '~/store/layout';
import IriModule from '~/store/iri';
import EnrollmentModule from '~/store/enrollment';

@Component<DefaultLayout>({
    components: {
        Header,
        FloatingFooter,
        Footer,
        StaticFooter,
        ScrollingFooter,
        ConfigurationDrawer,
    },
    mounted() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if ((this as any).$meta) (this as any).$meta().refresh();
    },
    icons: {
        faPrescription,
        faChevronUp,
        faChevronDown,
    },
})
export default class DefaultLayout extends Vue {
    @Resolve
    public layout!: LayoutModule;

    @Resolve
    public enrollment!: EnrollmentModule;

    @Resolve
    public iri!: IriModule;

    @Resolve
    public session!: SessionModule;
    public theme = theme;

    // Allows user to close the configuration drawer by hitting escape
    created() {
        window.addEventListener('keyup', e => {
            if (e.key === 'Escape') {
                this.drawer = false;
            }
        });
    }

    @Watch('this.$route', { immediate: true })
    setMockEservices() {
        /*
        This is new functionality that allows us to test different scenarios for the eServices that are run upon
        enrollment.  Please see the below pull request and swagger documentation for more information.

        Upon enrolling with the new endpoint, we have the option of passing an object along with the request
        that looks like this:

        "eServicesOptions": {
            "mockShouldSucceedPcfHasInsurance": true,
            "mockShouldSucceedFasWithinFpl": true
            mockShouldBeGovernmentProgramEligible: true
        }

        This object will tell the endpoint to not call the eServices and instead set values that we want to test.
        True and False in these circumstances will determine if the eServices should succeed or fail.

        Please see the "scenarios" object below for the different scenarios that can be tested.

        Adding ?mockEservices=1 to the end of the url will trigger the mock eServices to run with the scenario 1.
        Changing the number will allow testing of the various scenarios by mocking them in the apigateway.

        If done correctly, the scenario will be logged to the console for easy reference and debugging.


        https://dev.azure.com/TrialCardInc/Portico/_git/ApiGateway/pullrequest/52839
        https://apigateway-qa.trialcard.com/#/EdgeEnrollment/EServicesEnrollmentEnroll
        */
        const scenarios = {
            '1': {
                mockShouldSucceedPcfHasInsurance: true,
                mockShouldSucceedFasWithinFpl: true,
            },
            '2': {
                mockShouldSucceedPcfHasInsurance: true,
                mockShouldSucceedFasWithinFpl: false,
            },
            '3': {
                mockShouldSucceedPcfHasInsurance: false,
                mockShouldSucceedFasWithinFpl: true,
            },
            '4': {
                mockShouldSucceedPcfHasInsurance: false,
                mockShouldSucceedFasWithinFpl: false,
            },
            '5': {
                mockShouldSucceedPcfHasInsurance: false,
                mockShouldSucceedFasWithinFpl: false,
                mockShouldBeGovernmentProgramEligible: true,
            },
            '6': {
                mockShouldSucceedPcfHasInsurance: false,
                mockShouldSucceedFasWithinFpl: false,
                mockShouldBeGovernmentProgramEligible: false,
            },
        };
        const mockScenario = this.$route.query.mockEservices as '1'|'2'|'3'|'4'|'5'|'6';
        const shouldMockEservices = !!mockScenario
                                    && typeof mockScenario === 'string'
                                    && ['1', '2', '3', '4', '5', '6'].includes(mockScenario);
        if (shouldMockEservices) {
            // eslint-disable-next-line no-console
            console.warn(`NOTE: Mocking eServices with scenario ${mockScenario}`, scenarios[mockScenario]);
            this.enrollment.setShouldMockEservices(true);
            this.enrollment.setMockEservicesOptions(scenarios[mockScenario]);
        }
    }


    public get drawer() {
        return this.layout.drawer;
    }
    public set drawer(v) {
        this.layout.setDrawer(v);
    }
    public get mini() {
        return this.layout.mini;
    }
    public set mini(v) {
        this.layout.setMini(v);
    }
    public get iriOpen() {
        return this.iri.open;
    }
    public set iriOpen(v) {
        this.iri.toggleIriOpen(v);
    }

    public get menu(): object {
        return this.$settings.mainMenu;
    }
    public back() {
        this.$router.back();
    }

    public get brkPoints() {
        return {
            'brk-xs': this.$vuetify.breakpoint.xs,
            'brk-xs-only': this.$vuetify.breakpoint.xsOnly,
            'brk-sm': this.$vuetify.breakpoint.sm,
            'brk-sm-only': this.$vuetify.breakpoint.smOnly,
            'brk-sm-and-down': this.$vuetify.breakpoint.smAndDown,
            'brk-sm-and-up': this.$vuetify.breakpoint.smAndUp,
            'brk-md': this.$vuetify.breakpoint.md,
            'brk-md-only': this.$vuetify.breakpoint.mdOnly,
            'brk-md-and-down': this.$vuetify.breakpoint.mdAndDown,
            'brk-md-and-up': this.$vuetify.breakpoint.mdAndUp,
            'brk-lg': this.$vuetify.breakpoint.lg,
            'brk-lg-only': this.$vuetify.breakpoint.lgOnly,
            'brk-lg-and-down': this.$vuetify.breakpoint.lgAndDown,
            'brk-lg-and-up': this.$vuetify.breakpoint.lgAndUp,
            'brk-xl': this.$vuetify.breakpoint.xl,
            'brk-xl-only': this.$vuetify.breakpoint.xlOnly,
        };
    }
}
